import { BaseBus } from "./BaseBus";
import { DateFunctions } from "../static/date-functions";
import { v_LocationDetailBus } from "./v_LocationDetailBus";
import { CommonFunctions } from "../static/common-functions";
import { CommonValues } from "../static/CommonValues";

/*
 * Resource: fullName
 * Assigned: assignedDate
 * Status: dispatchAssignmentStatusName
 * IsPrimary: isPrimary
 * Start: startDate
 * Require Clock-in: requireFieldValidation ?
 * Last Updated Date: updateDt 
 * Last Updated User: updateUserName
 * dispatchAssignmentId
 */
export class DispatchAssignmentBus extends BaseBus
{
    constructor(busObj: DispatchAssignmentBus = null) {
        super(busObj);
        if (busObj != null) {
            this.insertDt = DateFunctions.getDate(busObj.insertDt);
            this.updateDt = DateFunctions.getDate(busObj.updateDt);
            this.assignedDate = DateFunctions.getDate(busObj.assignedDate);
            this.startDate = DateFunctions.getDate(busObj.startDate);
            this.endDate = DateFunctions.getDate(busObj.endDate);
        }

    }
    CID(): any {
        return this.dispatchAssignmentId;
    }
    setId(id: any) {
        this.dispatchAssignmentId = id;
    }
    setParentId(id: any) {
        this.dispatchId = id; 
    }

    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: v_LocationDetailBus = null) {
        this.assignedDate = new Date(date);
        this.assignedStatusId = CommonValues.DispatchAssignment_Assigned;
        this.startDate = date;
        this.isPrimary = true;
        this.assignedByPersonId = personId;
    }
    setCommon(userId: any, date: Date, companyId: any = null, personId: any = null) {
        if (!DateFunctions.isValidDate(this.insertDt)) {
            this.insertDt = date;
            this.insertUserId = userId;
        }
        this.updateDt = date;
        this.updateUserId = userId;
    }
    setBeforeSave () {
        this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
        this.updateDt = DateFunctions.getDateTimeWithUTCOffset(this.updateDt);
        this.startDate = DateFunctions.getDateTimeWithUTCOffset(this.startDate);
        this.assignedDate = DateFunctions.getDateTimeWithUTCOffset(this.assignedDate);
    }
    dispatchAssignmentId: any;
    dispatchId: any;
    newDispatchStatus: any;
    isPrimary: boolean;
    assignedPersonId: any;
    assignedPersonName: any;
    assignedByPersonName
    updatePersonName: any;
    assignedByPersonId: any;
    assignedDate: Date;
    assignedStatusId: any;
    startDate: Date;
    endDate: Date;
    insertUserId: any;
    insertDt: Date;
    updateUserId: any;
    updateDt: Date;
    requireFieldValidation: boolean;
    wasCallback: boolean;
    repairCode: any;
}
